<template>
    <div>
        <Poptip  v-model="isShowTop" :content="content" placement='top' :style="style"></Poptip>
        <Poptip  v-model="isShowRight" :content="content" placement='right' :style="style"></Poptip>
        <Poptip  v-model="isShowBotton" :content="content" placement='bottom' :style="style"></Poptip>
        <Poptip  v-model="isShowLeft" :content="content" placement='left' :style="style"></Poptip>
    </div>
</template>
<script>
export default {
  name: "tooltip",
  data: function() {
    return {
        isShowTop : false,
        isShowRight : false,
        isShowBotton : false,
        isShowLeft : false,
        style: {
            position: "absolute",
            left : "20px",
            top : "400px",
            width : "2px",
            height : "2px",
            display : "block"
        },
        content : "?"
    };
  },
  mounted: function() {
    //注册contextMenu动态加载组件
    this.$store.registerModule(["system", "tooltip"], {
        state: {
            $: this
        }
    });
  },
  methods: {
    //show 信息提示显隐
    show: function(isShow,event,tipStr) {
        if(isShow && event){
            this.content = tipStr;
        }else{
            this.isShowTop = false;
            this.isShowRight = false;
            this.isShowBotton = false;
            this.isShowLeft = false;
            this.content = tipStr;
        }
        
    },
    move:function(event){
        //鼠标上方显示
        if(window.innerHeight - event.clientY < 50){
            this.style.left = event.clientX + "px";
            this.style.top = event.clientY - 20 + "px";
            this.isShowTop = true;
            this.isShowRight = false;
            this.isShowBotton = false;
            this.isShowLeft = false;
            return;
        }
        //鼠标右方显示
        if(event.clientX < 50){
            this.style.left = event.clientX + 10 + "px";
            this.style.top = event.clientY + "px";
            this.isShowTop = false;
            this.isShowRight = true;
            this.isShowBotton = false;
            this.isShowLeft = false;
            return;
        }
        //鼠标下方显示
        if(event.clientY < 50){
            this.style.left = event.clientX + "px";
            this.style.top = event.clientY + 10 + "px";
            this.isShowTop = false;
            this.isShowRight = false;
            this.isShowBotton = true;
            this.isShowLeft = false;
            return;
        }
        //鼠标左方显示
        if(window.innerWidth - event.clientX < 200){
            this.style.left = event.clientX - 10 + "px";
            this.style.top = event.clientY + "px";
            this.isShowTop = false;
            this.isShowRight = false;
            this.isShowBotton = false;
            this.isShowLeft = true;
            return;
        }
        this.style.left = event.clientX + 20 + "px";
        this.style.top = event.clientY + "px";
        this.isShowTop = false;
        this.isShowRight = true;
        this.isShowBotton = false;
        this.isShowLeft = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/system/tooltip.vue